import { AppState } from 'app/store';

export const getSignInLink = (state: AppState) =>
  state.auth.services?.user?._links.signIn;

export const getSignOutLink = (state: AppState) =>
  state.auth.services?.user?._links.signOut;

export const getSignUpLink = (state: AppState) =>
  state.auth.services?.user?._links.signUp;

export const getAuthenticatedSelector = (state: AppState) =>
  state.auth.authenticated;

export const getApiKeyWebSelector = (state: AppState) => state.auth.apiKeyWeb;

export const getApiKeyWebLoadingState = (state: AppState) =>
  state.auth.apiKeyLoadingState;

export const getBootstrapLoadingState = (state: AppState) =>
  state.auth.bootstrapLoadingState;

export const getPasswordResetLinkSelector = (state: AppState) =>
  state.auth.services?.user?._links.forgotPassword;

export const getAccount = (state: AppState) => state.auth.account;

export const getDisplayName = (state: AppState) =>
  state.auth.account?.displayName;

export const getUserGuid = (state: AppState) => state.auth.account?.userGuid;

export const getInitials = (state: AppState) => state.auth.account?.initials;

export const getChangePasswordLink = (state: AppState) =>
  state.auth.services?.user?._links.changePassword;

export const getPasswordPolicyLink = (state: AppState) =>
  state.auth.services?.user?._links.passwordPolicy;

export const getListIdsLink = (state: AppState) =>
  state.auth.services?.['creator-identifiers']?._links.listIds;

export const getPasswordPolicy = (state: AppState) => state.auth.passwordPolicy;

export const getContributionClassesRolesDDLLink = (state: AppState) =>
  state.auth.services?.contributions?._links.contributionClassesAndRolesDDL;

export const getChangeEmailLink = (state: AppState) =>
  state.auth.services?.user?._links.changeEmail;

export const getVerifyEmailLink = (state: AppState) =>
  state.auth.services?.user?._links.verifyEmail;

export const getLastLoginTime = (state: AppState) => state.auth.lastLogin;

export const getConfirmSignUpLink = (state: AppState) =>
  state.auth.services?.user?._links.confirmSignUp;

export const getConfirmAuddlySignUpLink = (state: AppState) =>
  state.auth.services?.user?._links.confirmMigration;

export const getResendVerificationCodeLink = (state: AppState) =>
  state.auth.services?.user?._links.resendVerificationCode;

export const getAccountEmail = (state: AppState) =>
  state.auth.account?.accountEmail;

export const getCreateSignedConnectionUrlLink = (state: AppState) =>
  state.auth.services?.websockets?._links.createSignedConnectionUrl;

export const getUserPersonasDDLLink = (state: AppState) =>
  state.auth.services?.user?._links.userPersonasDDL;

export const getDeleteAccountLink = (state: AppState) =>
  state.auth.services?.user?._links.deleteAccount;

export const getVerificationCodeLink = (state: AppState) =>
  state.auth.services?.['verification-code']?._links.confirmCode;

export const getAppVersionsLink = (state: AppState) =>
  state.auth.services?.bootstrap?._links.getAppVersions;

export const getAccountConnectionProviders = (state: AppState) =>
  state.auth.services?.['account-connections']?.providers?.items;
